import { combineReducers } from 'redux';
import authReducer from './authReducer';
import commonReducer from './commonReducer';
import dashboardReducer from './dashboardReducer';
import categoryReducer from './categoryReducer';
import prefixReducer from './prefixReducer';
import locationsReducer from './locationsReducer';
import projectReducer from './projectReducer';
import assetReducer from './assetReducer';
import reportListReducer from './reportListReducer';
import ticketsReducer from './ticketsReducer';
import userReducer from './userReducer';
import batchAssetUpdatesReducer from './batchAssetUpdatesReducer';
import looseItemDashboardReducer from './looseItemDashboardReducer';
import bomConfigurationsReducer from './bomConfigurationsReducer';
import assembleBOMReducer from './assembleBOMReducer';
import pickListReducer from './pickListReducer';
import leaveListReducer from './leaveListReducer';
import assetCalendarReducer from './assetCalendarReducer';
import teamMembersReducer from './teamMembersReducer';
import teamMemberTrackerReducer from './teamMemberTrackerReducer';
import looseItemsAndPartsReducer from './looseItemsAndPartsReducer';
import overviewReportReducer from './overviewReportReducer';
import requestOrderReducer from './requestOrderReducer';
import employmentStatusEditorReducer from './employmentStatusEditorReducer';
import addLooseItemsPopupReducer from './addLooseItemsPopupReducer';
import billOfLadingReducer from './billOfLadingReducer';
import teamMemberHistoryReducer from './teamMemberHistoryReducer';
import addBomToPicklistReducer from './addBomToPicklistReducer';
import batchItemUpdatesReducer from './batchItemUpdatesReducer';
import createBatchOfAssetsReducer from './createBatchOfAssetsReducer';
import searchReducer from './searchReducer';
import notificationCenterReducer from './notificationCenterReducer';
import userLogsReducer from './userLogsReducer';
import trainingsReducer from './trainingsReducer';
import ticketsDashboardReducer from './ticketsDashboardReducer';
import assetsDashboardsReducer from './assetsDashboardsReducer';
import manageLooseItemsReducer from './manageLooseItemsReducer';
import ticketTypesReducer from './ticketTypesReducer';
import ticketRootCausesReducer from './ticketRootCausesReducer';
import tmDashboardReducer from './tmDashboardReducer';
import billOfLadingLogsReducer from './billOfLadingLogsReducer';
import uploadBoLLogsReducer from './uploadBoLLogsReducer';
import reportTemplatesReducer from './reportTemplatesReducer';
import activeLocationsMapReducer from './activeLocationsMapReducer';
import picklistDetailsReducer from './picklistDetailsReducer';
import maintenanceRequestReducer from './maintenanceRequestReducer';
import samsaraReducer from './samsaraReducer';

const rootReducer = combineReducers({
  authData: authReducer,
  commonData: commonReducer,
  dashboardData: dashboardReducer,
  assetData: assetReducer,
  categoryData: categoryReducer,
  prefixData: prefixReducer,
  locationsData: locationsReducer,
  projectData: projectReducer,
  reportListData: reportListReducer,
  ticketsData: ticketsReducer,
  userData: userReducer,
  batchAssetUpdatesData: batchAssetUpdatesReducer,
  looseItemDashboardData: looseItemDashboardReducer,
  bomConfigurationsData: bomConfigurationsReducer,
  assembleBOMData: assembleBOMReducer,
  picklistData: pickListReducer,
  leaveListData: leaveListReducer,
  assetCalendarData: assetCalendarReducer,
  teamMembersData: teamMembersReducer,
  teamMemberTrackerData: teamMemberTrackerReducer,
  looseItemsAndPartsData: looseItemsAndPartsReducer,
  overviewReportData: overviewReportReducer,
  requestOrderData: requestOrderReducer,
  employmentStatusesPopupData: employmentStatusEditorReducer,
  addLooseItemsPopupData: addLooseItemsPopupReducer,
  billOfLadingData: billOfLadingReducer,
  teamMemberHistoryData: teamMemberHistoryReducer,
  addBomToPicklistData: addBomToPicklistReducer,
  batchItemUpdatesData: batchItemUpdatesReducer,
  createBatchOfAssetsData: createBatchOfAssetsReducer,
  searchData: searchReducer,
  notificationCenterData: notificationCenterReducer,
  userLogsData: userLogsReducer,
  trainingsData: trainingsReducer,
  ticketsDashboardData: ticketsDashboardReducer,
  assetsDashboardsData: assetsDashboardsReducer,
  manageLooseItemsData: manageLooseItemsReducer,
  ticketTypesData: ticketTypesReducer,
  ticketRootCausesData: ticketRootCausesReducer,
  tmDashboardData: tmDashboardReducer,
  billOfLadingLogsData: billOfLadingLogsReducer,
  uploadBoLLogsData: uploadBoLLogsReducer,
  reportTemplatesData: reportTemplatesReducer,
  activeLocationsMapData: activeLocationsMapReducer,
  picklistDetailsData: picklistDetailsReducer,
  maintenanceRequestData: maintenanceRequestReducer,
  samsaraData: samsaraReducer
});

export default rootReducer;
